export default __webpack_public_path__ + "static/media/icon-circle-guarantors-header.23a64cdb.svg";